import { SCHOOL_PROPERTIES } from 'src/config/constants.ts'
import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

// The property is a boolean for template defaults but a string ('0'/'1') once a school has a DB override.
// Absence types stay editable unless the property is explicitly switched off.
export function isAbsenceTypesEditable(school) {
  const value = school?.properties?.[SCHOOL_PROPERTIES.SCHOOL_PROPERTY_ABSENCE_TYPES_EDITABLE]

  return !(value === false || value === '0' || value === 0)
}

export default function absenceTypesEditable({ store }) {
  const user = store.getters['users/me']
  if (!user) return

  if (isAbsenceTypesEditable(user.school)) return

  return { ...GlobalPrototypes.defaultRoute() }
}
